import React, { useState, useEffect } from 'react';
import { chargeTypeEnum } from 'components/CipManagementv2/components/CipThreshold';
import RangeInput from './RangeInput';

interface FilterOptionPoundPercentageProps {
  label: string;
  field: string;
  selectedValue: any;
  onChange: Function;
  type?: any;
  nested?: boolean;
}

const FilterOptionPoundPercentage = ({
  label,
  field,
  selectedValue = {},
  onChange,
  type = chargeTypeEnum.PERCENTAGE,
  nested = false
}: FilterOptionPoundPercentageProps) => {
  const [minValue, setMinValue] = useState(null) as any;
  const [maxValue, setMaxValue] = useState(null) as any;

  useEffect(() => {
    setMinValue(selectedValue.min || null);
    setMaxValue(selectedValue.max || null);
  }, [selectedValue]);

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'top' }}
    >
      {nested && (
        <div style={{ fontSize: '1rem', width: '50%', marginTop: '10px' }}>
          {label}
        </div>
      )}
      <div style={{ width: '100%', display: 'flex', gap: '1rem' }}>
        <RangeInput
          label="Min"
          type={type}
          chargeValue={minValue}
          onChange={value => {
            setMinValue(value);
            onChange(field, { min: value, max: maxValue });
          }}
        />
        <RangeInput
          label="Max"
          type={type}
          chargeValue={maxValue}
          onChange={value => {
            setMaxValue(value);
            onChange(field, { min: minValue, max: value });
          }}
        />
      </div>
    </div>
  );
};

export default FilterOptionPoundPercentage;
